"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelButton = exports.SearchIconWrapper = exports.SearchInputWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.SearchInputWrapper = (0, styled_1.default)('div') `
  position: relative;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  max-width: 290px;

  input {
    padding-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    padding-right: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    border-radius: ${(props) => props.isV9Profile
    ? (0, ui_theme_1.fromTheme)('provider_profile_border_radius')(props)
    : 'inherit'};

    // prevent borders from being cut off because outlines are drawn outside of the elements border
    // and outline is not a part of an element's dimensions
    margin-left: ${(0, ui_theme_1.fromTheme)('border_width')};
  }

  @media (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin-bottom: 0;
  }

  @media print {
    display: none;
  }
`;
exports.SearchIconWrapper = (0, styled_1.default)('div') `
  position: absolute;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
  right: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  svg path {
    fill: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  }
`;
exports.CancelButton = (0, styled_1.default)('button') `
  position: absolute;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  appearance: none;
  border: 0;
  margin: 0;
  background: transparent;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  cursor: pointer;
  outline: 0;

  svg path {
    fill: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  }

  &:focus {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
    border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')};
  }
`;
//# sourceMappingURL=styles.js.map